import worker from './worker'

const workerOut = {}

Object.keys(worker).forEach(key => workerOut[key] = JSON.parse(JSON.stringify(worker[key])))

export default workerOut
